<template lang="pug">
el-container
  el-header(height="auto")
    el-form(ref="form" label-suffix=":")
      el-col(:span="24")
        el-form-item(label="查询时间" style="width:100%")
          el-select(
            v-model="form.timeType"
            placeholder="选择时间类型"
            style="margin-right:12px;"
          )
            el-option(:value="1" label="上车时间")
            el-option(:value="2" label="到达时间")
          el-date-picker(
            v-model="form.timeRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
          )
      el-col(:span="24")
        el-form-item(label="乘客信息")
          el-select(
            v-model="form.passengerQueryType"
            placeholder="选择查询条件"
            style="margin-right:12px;width:120px"
            @change="form.passengerQueryValue = ''"
          )
            el-option(:value="1" label="手机号")
            el-option(:value="2" label="身份证号")
          el-input(
            v-model="form.passengerQueryValue"
            :placeholder="setPlaceHolder1"
            :maxlength="maxLength1"
            style="width:268px"
            clearable
          )
        el-form-item(label="司机信息")
          el-select(
            v-model="form.driverQueryType"
            placeholder="选择查询条件"
            style="margin-right:12px;width:120px"
            @change="form.driverQueryValue = ''"
          )
            el-option(:value="1" label="手机号")
            el-option(:value="2" label="身份证号")
          el-input(
            v-model="form.driverQueryValue"
            :placeholder="setPlaceHolder2"
            :maxlength="maxLength2"
            style="width:268px"
            clearable
          )
      el-col(:span="24")
        el-form-item(label="位置信息" style="width:100%")
          el-select(
            v-model="form.posType"
            placeholder="选择位置类型"
            style="margin-right:12px;"
          )
            el-option(:value="1" label="上车位置")
            el-option(:value="2" label="到达位置")
          el-select(
            v-model="form.provinceCode"
            placeholder="省份"
            @change='onChange'
            style="margin-right:12px;width:120px"
          )
            el-option(
              v-for="province in provinceList"
              :label="province.name"
              :value="province.provinceId"
              :key="province.provinceId"
            )
          el-select(
            v-model="form.cityCode"
            placeholder="市"
            style="margin-right:12px;width:120px"
          )
            el-option(
              v-for="city in cityList"
              :label="city.name"
              :value="city.cityCode"
              :key="city.cityCode"
            )
          //- el-input(
          //-   v-model="form.detailSite"
          //-   placeholder="请输入详细地址信息"
          //-   maxlength="200"
          //-   @focus='onFocus'
          //-   style="width:300px"
          //-   clearable
          //- )
          //- AmapSelector(v-model="form.detailSite")
          //- | {{form.detailSite | json}}
      el-col(:span="24")
        el-form-item(label="车辆信息" style="width:100%")
          el-input(
            v-model="form.plateNumber"
            placeholder="请输入车辆牌照号"
            maxlength="8"
            clearable
            style="width: 172px"
          )
      el-col(:span="24")
        el-form-item
          el-button(type="primary" :loading="isLoading" @click="search")
            | 查询
          el-button(type="warning" @click="reset")
            | 重置
  el-main
    grid(
      :remoteMethod="getTableData"
      ref="grid"
      layout="prev, pager, next, jumper"
    )
      el-table-column(label="乘客" align="center" min-width="150%")
        template(slot-scope="scope")
          p {{ scope.row.passengerInfo.userName }}
          p {{ scope.row.passengerInfo.idCard }}
          p {{ scope.row.passengerInfo.mobile }}
      el-table-column(label="司机" align="center" min-width="150%")
        template(slot-scope="scope")
          p {{ scope.row.driverInfo.userName }}
          p {{ scope.row.driverInfo.idCard }}
          p {{ scope.row.driverInfo.mobile }}
      el-table-column(label="上车时间" align="center")
        template(slot-scope="scope")
          span {{ scope.row.aboardTime | dateFormat }}
      el-table-column(label="上车地址" align="center" prop="origin.longAddr")
      el-table-column(label="到达时间" align="center")
        template(slot-scope="scope")
          span {{ scope.row.arriveTime | dateFormat }}
      el-table-column(label="到达地址" align="center" prop="destination.longAddr")
      el-table-column(label="牌照号" align="center" prop="plateNumber")
      el-table-column(label="车型信息" align="center" prop="carType")
      el-table-column(label="是否拼车" align="center" prop="poolStatus")
      el-table-column(label="操作")
        template(slot-scope="scope")
          el-button(type="text" @click="() => clickDetail(scope.row)") 详情

</template>
<script>
import moment from 'moment';
import grid from '@/components/grid';
import deepCopy from '@/utils/deepCopy';
import { findProvince, findCity, findHitchJourneyList } from '@/api/hitch';
import AmapSelector from '@/components/AmapSelector';

const now = moment().format('YYYY-MM-DD 00:00:00');
const start = moment(now).add(-6, 'days').format('YYYY-MM-DD 00:00:00');
const end = moment().format('YYYY-MM-DD 23:59:59');
const rangeTimeStart = moment(now).add(-119, 'days');
const rangeTimeEnd = moment(now);
const defaultForm = {
  timeType: 1,
  timeRange: [
    start, end,
  ],
  passengerQueryType: 1,
  driverQueryType: 1,
  passengerQueryValue: '',
  driverQueryValue: '',
  posType: 1,
};

export default {
  components: {
    grid,
    AmapSelector
  },
  filters: {
    dateFormat(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < rangeTimeStart || time.getTime() > rangeTimeEnd;
        }
      },
      form: deepCopy(defaultForm),
      provinceList: [],
      cityList: [],
    };
  },
  computed: {
    setPlaceHolder1() {
      return this.setPlaceHolder(this.form.passengerQueryType);
    },
    setPlaceHolder2() {
      return this.setPlaceHolder(this.form.driverQueryType);
    },
    maxLength1() {
      return this.maxLength(this.form.passengerQueryType);
    },
    maxLength2() {
      return this.maxLength(this.form.driverQueryType);
    }
  },
  mounted() {
    this.findProvince();
  },
  methods: {
    setPlaceHolder(type) {
      const placeholderMap = {
        1: '请输入手机号',
        2: '请输入身份证号'
      };
      return placeholderMap[type];
    },
    maxLength(type) {
      const maxLengthMap = {
        1: '11',
        2: '18'
      };
      return maxLengthMap[type];
    },
    clickDetail(item) {
      this.$router.push({
        name: 'hitchDetail',
        query: {
          guid: item.paxJourneyGuid,
        },
      });// 跳转详情页面
    },
    // 获取省市数据
    async findProvince() {
      const res = await findProvince();
      this.provinceList = res.data;
    },
    async findCity(guid) {
      const cityres = await findCity(guid);
      this.cityList = cityres.data;
    },
    getParams() {
      const {
        timeType,
        timeRange,

        passengerQueryType,
        passengerQueryValue,

        driverQueryType,
        driverQueryValue,

        posType,
        provinceCode,
        cityCode,

        plateNumber,
      } = this.form;
      const result = {
        plateNumber,
      };
      const [startTime, endTime] = timeRange || [];
      if (timeType === 1) {
        result.aboardStartTime = startTime;
        result.aboardEndTime = endTime;
      } else if (timeType === 2) {
        result.arriveStartTime = startTime;
        result.arriveEndTime = endTime;
      }

      if (passengerQueryType === 1) {
        result.passengerMobile = passengerQueryValue;
      } else if (passengerQueryType === 2) {
        result.passengerIdCard = passengerQueryValue;
      }
      if (driverQueryType === 1) {
        result.driverMobile = driverQueryValue;
      } else if (driverQueryType === 2) {
        result.driverIdCard = driverQueryValue;
      }

      if (posType === 1) {
        result.aboardProvinceCode = provinceCode;
        result.aboardCityCode = cityCode;
      } else {
        result.arriveProvinceCode = provinceCode;
        result.arriveCityCode = cityCode;
      }
      return result;
    },
    onChange(val) {
      if (val) {
        const result = this.provinceList.find(item => item.provinceId === val);
        this.findCity(result.guid);
      }
    },
    // 当输入详细地址后判断是否选择了省市
    /* onFocus() {
      if (!this.form.guid && !this.form.findCity) {
        this.$message('请选择省级，市');
      } else if (this.form.guid && !this.form.findCity) {
        this.$message('请选择市');
      }
    }, */
    search() {
      const {
        timeRange,
        userQueryValue,
        provinceCode,
        cityCode,
        plateNumber,
      } = this.form;
      // 判断查询条件是否为空
      if ((!timeRange || !timeRange[0] || !timeRange[1]) &&
      !userQueryValue && !provinceCode && !cityCode && !plateNumber) {
        this.$message.error('请选择至少一项查询条件');
        return;
      }

      this.$refs.grid.loadData(this.getParams());
    },
    reset() {
      this.form = deepCopy(defaultForm);
      this.$refs.grid.reset();
    },
    async getTableData(params) {
      const {
        page,
        rows,
        ...restParms
      } = params;
      restParms.startPage = page - 1;
      restParms.pageSize = rows;
      const { data } = await findHitchJourneyList(restParms);
      return { data: data.list, total: data.total };
    },
  }
};
</script>


<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/views/order/hitch/index.vue?2df526c4